import { createFileRoute } from "@tanstack/react-router";
import AbrirTiendaEnEspana from "@/pages/AbrirTiendaEnEspana";

// Nota SEO: title/description/og:*/twitter:*/canonical los emite <SEO />
// (Helmet, también en SSR) dentro de SolutionProgramPage. Declararlos también
// aquí duplicaba cada etiqueta en el HTML servido.
export const Route = createFileRoute("/abrir-tienda-en-espana")({
  component: AbrirTiendaEnEspana,
});
